export enum Appsumo {
  licenseKey = "appsumoLicenseKey",
}

export const appsumoLicenseKeyExpireTime = new Date(
  Date.now() + 30 * 60 * 1000,
).toUTCString();
